import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type BoostedJobRow = {
  job_id: string;
  boosted_since: string | null;
  boosted_until: string | null;
};

/**
 * Fetches the set of job-ids that currently have a live boost campaign.
 * Backed by the `active_boosted_jobs` view — publiek leesbaar.
 */
export const useBoostedJobIds = () => {
  return useQuery({
    queryKey: ["active-boosted-jobs"],
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    queryFn: async (): Promise<{
      ids: Set<string>;
      rows: BoostedJobRow[];
    }> => {
      const { data, error } = await supabase
        .from("active_boosted_jobs" as any)
        .select("job_id, boosted_since, boosted_until");
      if (error) {
        console.warn("[useBoostedJobIds] fetch failed", error);
        return { ids: new Set(), rows: [] };
      }
      const rows = ((data ?? []) as unknown) as BoostedJobRow[];
      return {
        ids: new Set(rows.map((r) => r.job_id)),
        rows,
      };
    },
  });
};
